<template>
    <b-td :id="'em-results-' + rowNum" class="cell-table forage-col" :class="{
        'gray-bg': rowNum % 2 !== 0,
    }">
        <div>
            <b-table-simple class="mb-0" width="100%">
                <b-tbody>
                    <RanchEMResultRow v-for="emResult in emResultData" :addition-view="false" :cropId="cropId"
                        :field="fieldId" :emResult="emResult?.enteric_methane_status" :key="emResult.id" :year="year" :rowIndex="emResultData.indexOf(forage)"
                        :dataLength="emResultData.length" />
                </b-tbody>
            </b-table-simple>
        </div>
    </b-td>
</template>
<script>
import { mapGetters } from "vuex"

import RanchEMResultRow from "@/components/spreadsheet/rows/RanchEMResultRow"
import { Filter } from "@/store/modules"

export default {
    name: "RanchForageTable",
    components: {
        RanchEMResultRow,
    },
    props: {
        cropId: { type: Number },
        fieldId: { type: String },
        emResultData: { type: Array },
        rowNum: { type: Number },
        year: { type: String },
        years: { type: Array },
    },
    data() {
        return {
            yearSelected: [],
        }
    },
    computed: {
        ...mapGetters({
            allFields: Filter.Getters.getFields,
            selectedFields: Filter.Getters.getSelectedFields,
        }),
    },
    mounted() {
        if (this.year !== null) this.yearSelected.push(this.year)
    },
}
</script>
<style scoped>
.cc-bg {
    background-color: #edf9dc;
    /* background-color: #bbd686; */
}

.cc-bg-dark {
    background-color: #c9ed96;
    /* background-color: #8eb63e; */
}

.gray-bg {
    background-color: #f6f7fb !important;
}

.addition-container {
    padding-left: 40px;
    padding-right: 84px;
}

.add-icon {
    background-color: #7774e7;
    color: white;
    cursor: pointer;
    padding-left: 14px;
}

.add-icon:hover,
.add-icon:focus {
    color: #ffffff;
    background-color: #8c8aeb;
}

.add-text {
    font-weight: 500;
    font-size: 14px;
}

.cell-table {
    padding: 0;
}

.complete {
    background-color: #00a200;
}

.arva-generated {
    background-color: #fedb80;
}

.delete {
    color: #cc0101;
}

/* v-select-old widths */
.field-select {
    width: 160px;
}

.year-select {
    background-color: white !important;
    width: 110px;
    font-size: 13px;
}

/* table-width */
.forage-col {
    width: 580px;
}

/* column sizing */
.date-column {
    min-width: 172px;
    max-width: 172px;
}

.type-column {
    min-width: 220px;
    max-width: 220px;
}

.amount-column {
    min-width: 160px;
    max-width: 160px;
}

.icon-column {
    min-width: 40px;
    max-width: 40px;
}

.icon-copy-column {
    min-width: 44px;
    max-width: 44px;
}
</style>